var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSapinline = function SvgSapinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 40,
    fill: "none",
    viewBox: "0 0 92 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sap_inline_svg__a)",
    fillRule: "evenodd",
    d: "M0 40h40.977L81.078 0H0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M48.117 8H40.11l.026 18.782-6.972-18.789H26.25l-5.952 15.692c-.633-3.993-4.772-5.37-8.03-6.403-2.15-.689-4.433-1.702-4.41-2.822.018-.92 1.222-1.772 3.613-1.645 1.604.087 3.022.216 5.84 1.574l2.773-4.818c-2.57-1.305-6.125-2.129-9.04-2.132h-.018c-3.398 0-6.228 1.098-7.982 2.907-1.223 1.262-1.883 2.868-1.91 4.643-.044 2.442.854 4.174 2.74 5.558 1.593 1.165 3.632 1.92 5.428 2.475 2.215.684 4.024 1.28 4.002 2.547a1.875 1.875 0 0 1-.526 1.243c-.553.569-1.4.782-2.572.805-2.26.048-3.937-.306-6.607-1.88l-2.466 4.88c2.667 1.512 5.5 2.271 8.717 2.271l.723-.005c2.801-.05 5.074-.72 6.88-2.169.103-.082.196-.166.292-.25l-.303 1.557L24.198 32l1.212-3.096c1.275.434 2.724.674 4.262.674 1.5 0 2.91-.227 4.16-.636L34.677 32l12.122.011.03-7.056h2.579c6.234 0 9.92-3.164 9.92-8.471-.002-5.91-3.585-8.485-11.211-8.485ZM29.672 24.054a7.26 7.26 0 0 1-2.556-.447l2.528-7.96h.049l2.487 7.983a7.505 7.505 0 0 1-2.508.424m18.914-4.574h-1.76v-6.415h1.76c2.345 0 4.217.779 4.217 3.166-.002 2.471-1.872 3.25-4.216 3.25",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sap_inline_svg__a",
    x1: 40.539,
    x2: 40.539,
    y1: 0,
    y2: 40.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#0097DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#007CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#006CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B3"
  })))));
};
export default SvgSapinline;